<template>
  <div>
    <IeBusinessEntityType v-model="businessEntityType" class="m-t-10" />

    <IeBusinessEntityLimitedForm
      v-if="businessEntityType === 'ie_limited'"
      v-model:business-entity="internalBusinessEntity"
      :compliance-data="complianceData"
      :freelancer="freelancer"
    />

    <IeBusinessEntitySoleTraderForm
      v-else-if="businessEntityType === 'ie_sole_trader'"
      v-model:business-entity="internalBusinessEntity"
      :compliance-data="complianceData"
      :freelancer="freelancer"
    />

    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <SubmitButton class="tw-mt-5" :text="$t('Save')" auto-submit />
  </div>
</template>

<script>
import IeBusinessEntityLimitedForm from '@/components/compliances/BusinessEntity/Ie/IeBusinessEntityLimitedForm.vue'
import IeBusinessEntitySoleTraderForm from '@/components/compliances/BusinessEntity/Ie/IeBusinessEntitySoleTraderForm.vue'
import IeBusinessEntityType from '@/components/compliances/BusinessEntity/Ie/IeBusinessEntityType.vue'
import { deepClone } from '@/utils/tools'

export default {
  name: 'FreelancerIeBusinessEntityForm',
  components: {
    IeBusinessEntityLimitedForm,
    IeBusinessEntitySoleTraderForm,
    IeBusinessEntityType,
  },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
    complianceData: {
      type: Object,
      required: true,
    },
    freelancer: {
      type: Object,
      required: true,
    },
  },
  data() {
    const internalBusinessEntity = deepClone(this.businessEntity)

    return {
      internalBusinessEntity,
    }
  },
  computed: {
    businessEntityType: {
      get() {
        return this.internalBusinessEntity.entityType
      },
      set(businessEntityType) {
        this.internalBusinessEntity.entityType = businessEntityType
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
  },
}
</script>
